import { useGetTreatment } from '@zg-rentals/split';

import accessUtils from '../utils/accessUtils';

import SplitTestConstants from '../constants/SplitTestConstants';

import type { SplitExperimentsProps } from '@zg-rentals/split';

export const useFlexiblePropertiesEntry = () => {
  const { data: splitExperiment, isLoading } = useGetTreatment({
    featureName: SplitTestConstants.ZRM_FLEXIBLE_PROPERTY_CREATION,
  });

  const splitExperiments: SplitExperimentsProps = splitExperiment
    ? { [SplitTestConstants.ZRM_FLEXIBLE_PROPERTY_CREATION]: splitExperiment }
    : {};

  const canAccessFlexibleProperties = accessUtils.canAccessFlexibleProperties({ splitExperiments });

  return { canAccessFlexibleProperties, isLoading };
};
